import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './actions'
Vue.use(Vuex)
const state = {
  markerDatas: [],
  areaDatas: [],
  lineDatas: [],
  smartDatas: [],
  categoryList: [],
  standardTrackData: []
}
export default new Vuex.Store({
  state,
  mutations,
  actions
})



// WEBPACK FOOTER //
// ./src/store/index.js